import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface FormGroupProps {
  isEnabled: boolean;
}

export const FormGroup = ({
  isEnabled,
  children,
}: PropsWithChildren<FormGroupProps>) => (
  <div
    className={classNames("divide-primary space-y-5 divide-y", {
      "pointer-events-none opacity-50": !isEnabled,
    })}
  >
    {children}
  </div>
);
